export enum NewsletterEditionStatus {
  Preparing = "Preparing",
  Finalizing = "Finalizing",
  AwaitingApproval = "Awaiting Approval",
  Approved = "Approved",
  Sending = "Sending",
  Published = "Published",
  Expired = "Expired",
}

export interface ReviewTodo {
  id: string;
  check_id:
    | 'image_alt'
    | 'toc_alignment'
    | 'em_dashes'
    | 'title_keywords'
    | 'button_https'
    | 'broken_link'
    | 'image_format'
    | 'feedback_unresolved'
    | 'forced_negation'
    | 'feedback_not_incorporated'
    | 'blueprint_alignment'
    | 'missing_send_date'
    | 'past_date_in_content'
    | 'intro_redundancy'
    | 'intro_spoiler';
  message: string;
  done: boolean;
  row_uuid: string | null;
  row_index?: number | null;
  expected_alt?: string | null;
  change_request_id?: string | null;
}

export interface NewsletterEdition {
  id: string;
  title: string;
  email_template: object;
  html_content: string;
  newsletter_timestamp: string;
  scheduled_send_start_date: string;
  created_at: string;
  updated_at: string;
  container: string;
  status: NewsletterEditionStatus;
  newsletter_edition_links: NewsletterEditionLink[];
  newsletter_edition_change_requests: NewsletterEditionChangeRequest[];
  onboarding_blueprint_id?: string;
  is_welcome_email?: boolean;
  email_template_backup_created_at?: string;
  stats_report_sent_at?: string;
  total_deliveries?: number;
  open_rate?: number;
  preheader?: string;
  rating?: number;
}

export interface CloseScheduledEdition {
  title: string;
  scheduledSendDate: string;
  daysApart: number;
}

export interface PostNewsletterEditionInput {
  title: string;
  email_template: object;
  html_content?: string;
  newsletter_timestamp: string;
  scheduled_send_start_date: string;
  onboarding_blueprint_id?: string;
}

export interface PutNewsletterEditionInput {
  title?: string;
  email_template?: object;
  html_content?: string;
  newsletter_timestamp?: string;
  scheduled_send_start_date?: string;
  preheader?: string;
}

export interface NewsletterEditionLink {
  url: string;
  title?: string;
  has_been_added?: boolean;
  instructions?: string;
  original_content?: boolean;
}

export interface NewsletterSubscriber {
  id: string;
  email: string;
  status?: string,
  source?: string,
  created_at: string;
  updated_at: string;
  suppressed_at?: string;
  custom_fields?: Record<string, string | number | boolean | null>;
}


export interface NewsletterEditionChangeRequest {
  id: string;
  request_text: string;
  has_been_addressed: boolean;
  newsletter_edition_id: string;
  submitted_by_id: string;
  created_at: string;
  updated_at: string;
}

export interface SubscriberFilters {
  status?: string[];
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}
